import { call } from "redux-saga/effects";
import actions from "../../constants/roHubAccessActions";
import constants from "../../constants/constants";
import { getDataFromAPI } from "../../utils/sagas";
import { APIs } from "../../utils/worker";

export function* getRestrictedHubsWorker({ data }) {
  const reqParams = {
    url: `${APIs.bffBaseURL}/inscan-service/menu-access/restricted-hubs`,
    successAction: actions.GET_RESTRICTED_HUBS_SUCCESS,
    errorAction: actions.GET_RESTRICTED_HUBS_ERROR,
    params: {
      authToken: `Bearer ${data?.token}`,
    },
  };
  const headers = {
    ...constants.HTTP_REQ_DEFAULT_HEADERS,
  };
  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET, headers);
}
